import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import storage from "../utils/storage";
import { STORAGE_KEYS } from "../utils/constants";

interface GuestGuardProps {
  children: React.ReactNode;
}

export default function GuestGuard({ children }: GuestGuardProps) {
  // Get the current workspace role from Redux
  const currentRole = useSelector((state: RootState) => state.workspace.currentRole);
  
  // Also check localStorage for role persistence
  const storedRole = storage.get(STORAGE_KEYS.CURRENT_ROLE);
  
  // Use Redux state if available, fallback to localStorage
  const effectiveRole = currentRole || storedRole;

  // ゲストユーザーの場合はタスクページにリダイレクト
  if (effectiveRole === 'guest') {
    return <Navigate to="/tasks" replace />;
  }

  return <>{children}</>;
}


